<template>
    <div class="card">
        <router-link :to="reviewUrl">
            <img :src="`${siteUrl}/screens/${map.screenshot}`" />
            <div class="mask"></div>
            <div class="map-content">
                <div class="map-meta">
                    <h3>{{ map.name }}</h3>
                    <div class="sub-header author"><i class="fa fa-user"></i>{{ map.author }}</div>
                    <div class="sub-header author"><i class="fa fa-info"></i>reviewed by {{ map.reviewer }}</div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import { settings } from '../framework/settings'
export default {
    props: {
        map: { type: Object, required: true },
    },
    data() {
        return {
            siteUrl: settings.siteUrl
        }
    },
    computed: {
        reviewUrl() {
            return `/review/${this.map._id}`;
        }
    },
}
</script>

<style scoped>
.card {
    position: relative;
    display: block;
    padding-top: 46%;
    margin-bottom: 4%;
    width: 100%;
    border-bottom: 4px solid rgb(60,60,64);
    overflow: hidden;
    transition-delay: 0s;
    transition-duration: 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
    transition-property: border-color;
}
.card .author {
    font-family: 'Coustard', sans-serif;
    font-size: 12px;
    font-weight: bold;
}
.card:hover {
    border-color: rgb(120,120,120);
}
.card > a {
    display: block;
    color: white;
}
.card img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
}
.mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, transparent 0%, transparent 25%, #000 90%, #000 100%);
}

.map-content {
    position: absolute;
    bottom: 16px;
    left: 16px;
    right: 16px;
}

.card h3 {
    font-family: 'Sanchez';
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5em;
    letter-spacing: .025em;
    margin: 0 0 8px 0;
}

.sub-header {
    color: rgba(255,255,255, 0.7);
}

.sub-header .fa {
    margin-right: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/MapCard.vue